module.exports = __webpack_public_path__ + "img/4f968c0.jpg";